
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';
import _ from 'lodash';
import eventTrackingMixins from '~/mixins/eventTrackingMixins.js';
import eventTrackingFamilySiteProductCardsMixins from '~/mixins/eventTrackingFamilySiteProductCardsMixins';

export default {
  name: 'HappyKidsProductCarousel',

  mixins: [eventTrackingMixins, eventTrackingFamilySiteProductCardsMixins],

  components: { VueSlickCarousel },

  props: {
    data: {
      type: Object,
      default: () => ({
      }),
    },
  },

  data () {
    return {
      carouselDefaultSettings: {
        "arrows": true,
        "dots": true,
        "infinite": false,
        "speed": 500,
        "slidesToShow": 4,
        "slidesToScroll": 1,
        "touchThreshold": 5,
        "autoplay": false,
        "responsive": [
          {
            "breakpoint": 1024,
            "settings": {
              "slidesToShow": 2,
              "arrows": false,
            }
          },
          {
            "breakpoint": 570,
            "settings": {
              "slidesToShow": 1.25,
              "arrows": false
            }
          }
        ]
      },
      carouselKey: 0,
      categoryActiveIndex: 0,
      windowWidth: 0,
    }
  },
  computed: {
    productData () {
      return this.data?.productData;
    },
    dataIndex() {
      return this.data?.dataIndex || '';
    },
    productCategory () {
      return this.productData?.AnchorCode ? `${this.productData?.AnchorCode}-category` : null;
    },
    showSubcategories() {
      if ( !this.productData?.CoverageType ) return false;
      return this.productData.CoverageType && this.productData?.CoverageType.length > 1;
    },
    subcategoryList() {
      return this.productData.CoverageType;
    },
    productList() {
      if (!this.productData?.CoverageType) return false;

      if (this.$route.query[this.productCategory]) {
        // tracking with route query
        const products =  this.productData?.CoverageType.filter((type) => type.Slug === this.$route.query[this.productCategory])[0];
        return products !== undefined ? products : this.productData?.CoverageType[this.categoryActiveIndex];
      } else {
        // tracking with categoryActiveIndex
        return this.productData?.CoverageType[this.categoryActiveIndex];
      }

    },
    initCarousel() {
      let customSlidesToShow = this.carouselConfig.slidesToShow;
      if ( this.carouselConfig.responsive ) {
        this.carouselConfig.responsive.filter((size) => {
          if ( this.windowWidth <= size.breakpoint ) {
            customSlidesToShow = size.settings.slidesToShow;
          }
          return customSlidesToShow;
        })
      }
      return this.productList?.Products?.length >= customSlidesToShow;
    },
    carouselConfig() {
      // override default setting from data?.carouselCustomSetting
      return { ...this.carouselDefaultSettings, ...this.data?.carouselCustomSetting };
    },
    validSubcategoriesSlug() {
      // check if any subcategories slug is empty
      return this.productData?.CoverageType.some((type) => type.Slug === null);
    }
  },
  watch: {
    '$route.query' (newVal, oldVal) {
      if (newVal !== oldVal) {
        // trigger init-ed carousel change then update key value to force show updated slides
        this.carouselKey += 1;
      }
    },
    categoryActiveIndex(newVal, oldVal) {
      if (newVal !== oldVal) {
        // trigger init-ed carousel change then update key value to force show updated slides
        this.carouselKey += 1;
      }
    }
  },
  mounted() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
    this.checkFocusSection();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    updateCategory (value, activeIndex) {
      this.categoryActiveIndex = activeIndex || 0;

      if (!this.productCategory) return;
      if (this.validSubcategoriesSlug) return;

      if (!this.$route.query[this.productCategory]) {
        this.$router.push({
          query: { ...this.$route.query, [this.productCategory]: value },
          hash: this.$route.hash
        })
      } else {
        this.$router.replace({
          query: { ...this.$route.query, [this.productCategory]: value },
          hash: this.$route.hash
        });
      }
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    checkFocusSection() {
      if (this.$route.hash) {
        const targetId = this.$route.hash.substring(1);
        const section = document.getElementById(targetId);
        if ( section ) {
          setTimeout(() => {
            section.scrollIntoView({ behavior: 'smooth' });
          }, 300);
        }
      }
    }
  }
}
